import { useMutation } from '@apollo/client';
import type { ReactNode } from 'react';
import { toast } from 'react-toastify';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { Confirm } from '~/components/common/Confirm';
import type { RefetchQueries } from '~/utils/graphql';

export const DELETE_DIAGRAM = graphql(`
  mutation DeleteDiagram($id: ID!) {
    diagramDelete(id: $id) {
      result {
        id
      }
    }
  }
`);

type Props = {
  diagramId: string;
  refetchQueries: RefetchQueries;
  children: (showModal: () => void, loading: boolean) => ReactNode;
};

export function DeleteDiagram(props: Props) {
  return (
    <ApolloProviderV4>
      <DeleteDiagramInner {...props} />
    </ApolloProviderV4>
  );
}
function DeleteDiagramInner({ diagramId, refetchQueries, children }: Props) {
  const [deleteDiagram, { loading }] = useMutation(DELETE_DIAGRAM, {
    variables: { id: diagramId },
    refetchQueries,
  });

  async function handleDelete() {
    try {
      await deleteDiagram();
      toast.success('Diagram deleted successfully.');
    } catch (err) {
      toast.error('There was a problem deleting the diagram.');
      console.log('Error deleting diagram', err);
    }
  }

  return (
    <Confirm
      onConfirm={handleDelete}
      text="The selected image and all of its areas will be permanently deleted."
    >
      {onConfirm => children(onConfirm, loading)}
    </Confirm>
  );
}
